<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Сфера деятельности'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/orgSpheres', ['fetch']),
  computed: mapGetters('dictionary/orgSpheres', ['list'])
}
</script>
